import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const useSignUp = (postData) => {
  return http().post(endpoints.auth.signUp, postData);
};

export function usePostSignUp() {
  const queryClient = useQueryClient();
  return useMutation(useSignUp, {
    onSuccess: () => {
      queryClient.invalidateQueries(["useSignUp"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
